import * as React from 'react';
import { UIText2, Tooltip } from '@cian/ui-kit';
import { IconFunctionalInformationCircle16 } from '@cian/ui-kit-design-tokens/icons';

import * as styles from './actual.css';

interface IActualProps {
  label: string;
  title: string;
  description: React.ReactNode;
}
export const Actual = ({ label, title, description }: IActualProps) => {
  return (
    <div className={styles['actual']}>
      <div className={styles['label']}>
        <UIText2 color="text-secondary-default">{label}</UIText2>
      </div>
      <Tooltip theme="white" header={title} placement="right" title={description}>
        <IconFunctionalInformationCircle16 color="icon-main-default" />
      </Tooltip>
    </div>
  );
};

Actual.displayName = 'Actual';
